import * as React from 'react';
class BOM {
    static register = {
        BOM_ADD_TO_QUOTE: { slug: 'BOM_ADD_TO_QUOTE' },
        BOM_ADD_TO_CART: { slug: 'BOM_ADD_TO_CART' },
        VIEW_BOM: { slug: 'VIEW_BOM', render: <></> }
    };
    static register_external = {
        BOM_ADD_TO_CART: { slug: 'BOM_ADD_TO_CART', render: <></> },
        VIEW_BOM: { slug: 'VIEW_BOM', render: <></> },
        DOWNLOAD_BOM: { slug: 'DOWNLOAD_BOM', render: <></> }
    }
}

export default BOM;